// src/hooks/useApi.js
import { useState, useEffect } from "react";
import apiClient from "../api/apiClient";

export function useApi(
  url,
  { method = "get", data = null, auth = false, deps = [] } = {}
) {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiClient({ url, method, data, auth });
        setResponse(res.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, deps); // dependency array for re-fetching

  return { response, loading, error };
}
